// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__3BFz3","adWrapper":"styles_adWrapper__3CG8e","ad":"styles_ad__2TY03","loadMore":"styles_loadMore__Xrwtf","boxLoader":"styles_boxLoader__1b-gK"};